import { appStatus } from '../use/useAppStatus'; 
import { IStructureNotification } from '../interfaces/structure-notification.interface';
import { useTouchpointsHTTP } from "../use/useTouchpointsHTTP";

/*
  declarations
*/
const touchPointsComposable: any = useTouchpointsHTTP();

// Sync in-apps notification to Local storage
function SyncNotifLocal(syncData: any){
  console.log("SyncNotifLocal---")

  //Remove all local in-apps notification
  const localNotifData = localStorage.getItem("notificationData");
  if (localNotifData !== null) {
    localStorage.removeItem("notificationData");
  }

  if (syncData !== null) {

    const syncNotifLocalStorage = [];

    for (const curNotif in syncData)
    {
        const localData = {
          back_end_id: syncData[curNotif].tp_in_app_notifications_id,
          id: syncData[curNotif].notification_id,
          type: syncData[curNotif].type,
          icon: syncData[curNotif].icon,
          asset: syncData[curNotif].asset,
          textCollapsed: syncData[curNotif].textCollapsed,
          textCollapsedSummary: syncData[curNotif].textCollapsedSummary,
          textExpanded: syncData[curNotif].textExpanded,
          time: syncData[curNotif].time,
          display: syncData[curNotif].display,
          viewed: syncData[curNotif].viewed
        }

        const syncNotifData = [localData];
        syncNotifLocalStorage.push(localData);

        // Save notification data to appStatus to trigger update
        appStatus.notificationList.push(JSON.stringify(syncNotifData));
      }

      // Save notification data to localStorage to avoid keep pull data from API
      localStorage.setItem("notificationData", JSON.stringify(syncNotifLocalStorage));
    }
    
}

// Method to save user in-app notification
async function SaveInAppNotif(syncData: any){
  const insertInAppNotification = {
    id: syncData[0].id,
    type: syncData[0].type,
    icon: syncData[0].icon,
    asset: syncData[0].asset,
    textCollapsed: syncData[0].textCollapsed,
    textCollapsedSummary: syncData[0].textCollapsedSummary,
    textExpanded: syncData[0].textExpanded,
    time: syncData[0].time,
    display: syncData[0].display,
    viewed: syncData[0].viewed
  }

  const newNotifData = [
    insertInAppNotification
  ];

  let username = appStatus.userName;
  // If username not init yet, use localstorage
  if(appStatus.userName == null || appStatus.userName == "" || appStatus.userName == undefined){
    if(localStorage.getItem("username")) {
      username = localStorage.getItem("username")!;
    }
  }

  const existingLocalData = localStorage.getItem("notificationData");
  if (existingLocalData != null) {
    // Check is notification trigger before?
    const notificationData = JSON.parse(existingLocalData)  
    for (const curNotif in notificationData){
        if (notificationData[curNotif].id ===  newNotifData[0].id){
            return;
        }
    }
  }

  // Save notification data to localStorage first to avoid multiple trigger when waiting for API response
  const existingData = localStorage.getItem("notificationData");
  const newData: IStructureNotification = {
    back_end_id: 0, 
    id: newNotifData[0].id,
    type: newNotifData[0].type,
    icon: newNotifData[0].icon,
    asset: newNotifData[0].asset,
    textCollapsed: newNotifData[0].textCollapsed,
    textCollapsedSummary: newNotifData[0].textCollapsedSummary,
    textExpanded: newNotifData[0].textExpanded,
    time: newNotifData[0].time,
    display: true,
    viewed:false
  };

  if (existingData === null) {
    if (newNotifData) {
      localStorage.setItem("notificationData", JSON.stringify(newNotifData));
      return;
    }
  }
  else{
    const existingDataString = localStorage.getItem("notificationData");
    const existingData: IStructureNotification[] = JSON.parse(existingDataString || "[]");
    // Add the new data to the existing array
    existingData.push(newData);
    // Store the updated array back into localStorage
    localStorage.setItem("notificationData", JSON.stringify(existingData));
  }

  //return;

  await touchPointsComposable.insertInAppNotifications(username, insertInAppNotification)
  .then(function (response: any) {
    // Save notification data to localStorage to avoid user refresh and lost all previous notification
    const existingData = localStorage.getItem("notificationData");
    if (existingData !== null) {
      const updateLocalData = localStorage.getItem("notificationData");
      const updatedData: IStructureNotification[] = JSON.parse(updateLocalData || "[]");
      if (updateLocalData != null) {
        // Check is notification trigger before?
        const notificationDataUpdated = JSON.parse(updateLocalData)  
        for (const curNotif in notificationDataUpdated){
            if (notificationDataUpdated[curNotif].id ===  newNotifData[0].id){
              // Updatec notification back_end_id on local storage
              notificationDataUpdated[curNotif].back_end_id = response.data.id;
              // Store the updated array back into localStorage
              localStorage.setItem("notificationData", JSON.stringify(notificationDataUpdated));
              return;
            }
        }
      }
    }

  })
  .catch(function (error: Error) {
    console.log(error);
  });

}

// Method to update user in-app notification
async function UpdateInAppNotifViewedStatus(syncbackendID: number){
  
  // Method to update user in-app notification
  const backendID = syncbackendID
  const new_viewed_status = true;

  await touchPointsComposable.updateInAppNotifications(localStorage.getItem("username"), backendID, new_viewed_status)
  .then(function (response: any) {
    console.log("Updated In-App Notifications."+backendID);
  })
  .catch(function (error: Error) {
    console.log(error);
  });
  
}


export function useLocalNotificatiSync() {
  return {
    SyncNotifLocal,
    SaveInAppNotif,
    UpdateInAppNotifViewedStatus
  };
}